





















import { formatDate } from '@/web/utils/format';
import Vue from 'vue';
import StudentQuizSubmissionViewer from '@/web/components/quizzes/StudentQuizSubmissionViewer';

export default Vue.extend({
  name: 'StudentSolvedQuizzesTable',
  props: {
    items: {
      type: Array,
    },
  },
  data() {
    return {
      tableFields: [
        {
          name: 'name',
          title: this.$t('QUIZZES.TABLE.QUIZ'),
          cssClass: 'h5',
        },
        {
          name: 'status',
          title: this.$t('QUIZZES.TABLE.STATUS'),
          cssClass: 'd-flex align-items-center',
        },
        {
          name: 'created',
          title: this.$t('QUIZZES.TABLE.DATE_TAKEN'),
        },
        {
          name: 'action',
          shrink: true,
          cssClass: 'p-0 text-center',
        },
      ],
    };
  },
  methods: {
    viewSolvedQuiz(solvedQuiz) {
      console.log('viewing', solvedQuiz);
      this.$modal.show(
        StudentQuizSubmissionViewer,
        {
          solvedQuiz,
        },
        {
          classes: ['vm--inline-modal'],
        }
      );
    },
    formatDate(date: string): string {
      if (!date) return '';
      return formatDate(date, 'date-time');
    },
    getStatus(solvedQuizData) {
      if (solvedQuizData?.quiz_snapshot?.is_gradable) {
        if (solvedQuizData.is_graded) {
          if (solvedQuizData.is_passed) {
            return this.$t('QUIZZES.STATUS.PASSED');
          } else {
            return this.$t('QUIZZES.STATUS.FAILED_WITH_SCORE', {
              score: solvedQuizData.grade_achieved_score,
            });
          }
        } else {
          // not yet graded
          return this.$t('QUIZZES.STATUS.IN_REVIEW');
        }
      } else {
        return this.$t('QUIZZES.STATUS.SUBMITTED');
      }
    },
    formatStatus(solvedQuizData) {
      if (solvedQuizData?.quiz_snapshot?.is_gradable) {
        if (solvedQuizData.is_graded) {
          if (solvedQuizData.is_passed) {
            return 'passed';
          } else {
            return 'failed';
          }
        } else {
          return 'review';
        }
      } else {
        return 'submitted';
      }
    },
  },
});
